import { render, staticRenderFns } from "./orderCar.vue?vue&type=template&id=111dda8b&scoped=true"
import script from "./orderCar.vue?vue&type=script&lang=js"
export * from "./orderCar.vue?vue&type=script&lang=js"
import style0 from "./orderCar.vue?vue&type=style&index=0&id=111dda8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111dda8b",
  null
  
)

export default component.exports